import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import Vacancies from "./OpportunitiesTabs/Vacancies";
import MartimeCareers from "./OpportunitiesTabs/MartimeCareers";
import MartimeStudies from "./OpportunitiesTabs/MartimeStudies";
import Cadetship from "./OpportunitiesTabs/Cadetship";
import SupplyChainManagement from "./OpportunitiesTabs/SupplyChainManagement";
import CadetshipTraining from "./OpportunitiesTabs/CadetshipTraining";
import RFQSubmissions from "./OpportunitiesTabs/RFQSubmissions";
import FleetManagement from "./OpportunitiesTabs/FleetManagement";
import OpportunitiesLegislation from "./OpportunitiesTabs/OpportunitiesLegislation";
import OpportunitiesSBDForms from "./OpportunitiesTabs/OpportunitiesSBDForms";
import OpportunitiesGeneralConditions from "./OpportunitiesTabs/OpportunitiesGeneralConditions";
import OpportunitiesCodeOFConduct from "./OpportunitiesTabs/OpportunitiesCodeOFConduct";

const sectionComponents = {
  "vacancies": <Vacancies />,
  "maritime-careers": <MartimeCareers />,
  "cadetship": <Cadetship />,
  'CadetshipTraining': <CadetshipTraining />,
  "supply-chain": <SupplyChainManagement />,
  "maritime-studies": <MartimeStudies />,
  "RFQ-Submissions": <RFQSubmissions />,
  "Fleet-Management": <FleetManagement />,
  "Opportunities-Legislation": <OpportunitiesLegislation />,
  "Opportunities-SBDForms": <OpportunitiesSBDForms/>,
  "Opportunities-GeneralConditions": <OpportunitiesGeneralConditions/>,
  "Opportunities-CodeOFConduct": <OpportunitiesCodeOFConduct/>,

};

function OpportunitiesTab() {
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const initialSection = queryParams.get("section") || "vacancies";

  const [currentSection, setCurrentSection] = useState(initialSection);

  const handleClick = (section) => {
    setCurrentSection(section);
    navigate(`/opportunities?section=${section}`);
    const closeBtn = document.querySelector(".btn-cus");
    if (closeBtn) closeBtn.click();
  };
  useEffect(() => {
    const updatedSection = queryParams.get("section");
    setCurrentSection(updatedSection);
    const el = document.getElementById(currentSection);
    if (updatedSection && sectionComponents[updatedSection]) {
      if (el && queryParams.get("section") !== null) {
        const yOffset = -150;
        const y = el.getBoundingClientRect().top + window.scrollY + yOffset;
        setTimeout(() => {
          window.scrollTo({ top: y, behavior: "smooth" });
        }, 100);
      } else {
        setTimeout(() => {
          window.scrollTo({ top: 0, behavior: "smooth" });
        }, 100);
      }
      const isCadetship = updatedSection.toLowerCase() === "cadetship" || updatedSection.toLowerCase() === "cadetshiptraining";
      const collapseEl = document.getElementById("collapseTwo");
      if (collapseEl && !isCadetship && collapseEl.classList.contains("show")) {
        collapseEl.classList.remove("show");
      }
    } else {
      setCurrentSection("maritime-careers");
      const collapseEl = document.getElementById("collapseTwo");
      if (collapseEl) collapseEl.classList.remove("show");
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 100);
    }
  }, [location.search, location]);

  return (
    <section className="ManagementTeam px-3 small-anchor" id="ManagementTeam">
      <div className="container max-1330 mx-auto">
        <div className="row g-3 g-sm-4 g-md-5">
          <div className="col-lg-3">
            <div className="position-stiicky top-150">
              <div className="d-lg-none text-end">
                <i
                  className="bi bi-list  border-0 ms-auto font-32"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasResponsive"
                  aria-controls="offcanvasResponsive"
                ></i>
              </div>
              <div
                className="offcanvas-lg offcanvas-end"
                tabIndex="-1"
                id="offcanvasResponsive"
                aria-labelledby="offcanvasResponsiveLabel"
              >
                <div className="offcanvas-header d-lg-none">
                  <h5 className="offcanvas-title" id="offcanvasResponsiveLabel">
                    Our Services
                  </h5>
                  <button
                    type="button"
                    className="btn-close btn-cus"
                    data-bs-dismiss="offcanvas"
                    data-bs-target="#offcanvasResponsive"
                    aria-label="Close"
                  ></button>
                </div>
                <div
                  className="accordion leftMenu px-3 px-lg-0 pb-3 pb-md-0 overflow-auto overflow-md-visible"
                  id="accordionExample"
                >
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <button

                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOne"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                        className={`accordion-button noAfter  ${currentSection === "maritime-careers" ? "collapsed gray-active" : "collapsed"}`}
                        onClick={() => handleClick("maritime-careers")}
                      >
                        Maritime Careers
                      </button>
                    </h2>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <button

                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOne"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                        className={`accordion-button noAfter  ${currentSection === "vacancies" ? "collapsed gray-active" : "collapsed"}`}
                        onClick={() => handleClick("vacancies")}
                      >
                        Vacancies
                      </button>
                    </h2>

                  </div>


                  {/* <div className="accordion-item">
                    <h2 className="accordion-header">
                      <button
                        className={`accordion-button ${currentSection?.toLowerCase() === "cadetship" || currentSection?.toLowerCase() === "cadetshiptraining" ? "" : "collapsed"}`}
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseTwo"
                        aria-expanded="false"
                        aria-controls="collapseTwo"
                      >
                        Cadetship
                      </button>
                    </h2>
                    <div
                      id="collapseTwo"
                      className={`accordion-collapse ${currentSection?.toLowerCase() === "cadetship" || currentSection?.toLowerCase() === "cadetshiptraining" ? "" : "collapse"}`}
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body p-0">
                        <ul>
                          <li>
                            <button
                              type="button"
                              className={
                                currentSection?.toLowerCase() === "cadetship" ? "active" : ""
                              }
                              onClick={() => handleClick("cadetship")}
                            >
                              Cadetship​ Introduction
                            </button>
                          </li>
                          <li>
                              <button
                                type="button"
                                className={
                                  currentSection === "cadetshiptraining" ? "active" : ""
                                }
                                onClick={() => handleClick("cadetshiptraining")}
                              >
                                Cadetship Training
                              </button>
                            </li>                   
                        </ul>
                      </div>
                    </div>
                  </div> */}
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <button
                        className={`accordion-button ${currentSection?.toLowerCase() === "supply-chain" || currentSection?.toLowerCase() === "supply-chain" ? "" : "collapsed"}`}
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseTwo"
                        aria-expanded="false"
                        aria-controls="collapseTwo"
                      >
                        Supply Chain Management
                      </button>
                    </h2>
                    <div
                      id="collapseTwo"
                      className={`accordion-collapse ${currentSection?.toLowerCase() === "supply-chain" || currentSection?.toLowerCase() === "AboutGBV" ? "" : "collapse"}`}
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body p-0">
                        <ul>
                          <li>
                            <button
                              type="button"
                              className={
                                currentSection?.toLowerCase() === "supply-chain" ? "active" : ""
                              }
                              onClick={() => handleClick("supply-chain")}
                            >
                              OVERVIEW
                            </button>
                          </li>
                          <li>
                            <button
                              type="button"
                              className={
                                currentSection === "Opportunities-Legislation" ? "active" : ""
                              }
                              onClick={() => handleClick("Opportunities-Legislation")}
                            >Legislation
                            </button>
                          </li>
                          <li>
                            <button
                              type="button"
                              className={
                                currentSection === "Opportunities-SBDForms" ? "active" : ""
                              }
                              onClick={() => handleClick("Opportunities-SBDForms")}
                            >SBD Forms
                            </button>
                          </li>
                          <li>
                            <button
                              type="button"
                              className={
                                currentSection === "Opportunities-GeneralConditions" ? "active" : ""
                              }
                              onClick={() => handleClick("Opportunities-GeneralConditions")}
                            >General Conditions
                            </button>
                          </li>
                          <li>
                            <button
                              type="button"
                              className={
                                currentSection === "Opportunities-CodeOFConduct" ? "active" : ""
                              }
                              onClick={() => handleClick("Opportunities-CodeOFConduct")}
                            >Code OF Conduct
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>                 



                  <div className="accordion-item d-none">
                    <h2 className="accordion-header">
                      <button

                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOne"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                        className={`accordion-button noAfter  ${currentSection === "maritime-studies" ? "collapsed gray-active" : "collapsed"}`}
                        onClick={() => handleClick("maritime-studies")}
                      >
                        Maritime Studies
                      </button>
                    </h2>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-9 col-md-8">
            <div id={currentSection}>
              {sectionComponents[currentSection] || <Vacancies />}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default OpportunitiesTab;
